import { observer } from 'mobx-react';
import React from 'react';

import { Badge, Box, IconButton, Link } from '@mui/material';
import store from 'store';

import MessageIcon from '@common/assets/icons/Messages.svg';
import { ROLE, checkRole } from '@common/components/RBAC';

function MessagesIcon() {
	const isDemoUser = checkRole(ROLE.DEMO_TIS);

	const Wrapper = (isDemoUser ? Box : Link) as React.ElementType;

	if (store.profile.checkRole('Partner') || store.profile.checkRole('Partner Invitee')) {
		return null;
	}

	return (
		<Wrapper {...(!isDemoUser && { href: '/chat' })}>
			<Badge badgeContent={store.chat.unreadCount} color="primary">
				<IconButton size="large" disabled={isDemoUser}>
					<MessageIcon />
				</IconButton>
			</Badge>
		</Wrapper>
	);
}

export default observer(MessagesIcon);
